import React from "react";
import { Button, Grid, Typography, Stack } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Modal from "../../Components/Modal";
import { accessProfile } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IRemoveProfileProps {
  idProfile: number;
  reloadResourceTable: () => void;
  close: () => void;
}

const RemoveProfile: React.FC<IRemoveProfileProps> = ({
  idProfile,
  reloadResourceTable,
  close,
}) => {
  const { setLoading, loading } = useGlobalContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleCloseModal = () => close();

  const handleRemoveAccessProfile = async () => {
    if (idProfile === 0) return;

    setLoading?.(true);
    const { data = "", status = 500, message = "" } = await accessProfile.delete(`${idProfile}`);
    setLoading?.(false);

    if (data || message) {
      const variant = status === 200 ? "success" : "error";
      enqueueSnackbar(message, { variant });
    }

    reloadResourceTable();
    close();
  };

  return (
    <Modal
      title="Remover perfil de acesso"
      open={!loading}
      closeModal={handleCloseModal}
      maxWidth="sm"
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Tem certeza de que deseja remover este perfil de acesso?
            <Typography component="span" fontWeight="bold" color="error">
              {" "}
              Esta ação é irreversível!
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              aria-label="Cancelar remoção"
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleRemoveAccessProfile}
              startIcon={<DeleteForeverIcon />}
              aria-label="Confirmar remoção do perfil"
            >
              Remover perfil
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RemoveProfile;
